import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/index/a-z")({
  component: () => <Outlet />,
});
